/* eslint-disable prefer-destructuring */
import { API_KEYS, Api } from './base.api';
import { downloadBlob, SCOPE_TYPE } from './utils';

export const ocppMessagesApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchOcppMessages: builder.query<any, any>({
      query: (params) => ({
        url: `/internal/core/v2/chargers/${params.chargerId}/${API_KEYS.MESSAGE}`,
        params,
        method: 'GET',
      }),
    }),
    fetchOcppMessagesByCharger: builder.query<
      any,
      { chargerId: string; from: string; to: string; limit: number }
    >({
      query: ({ chargerId, from, to, limit }) => ({
        url: `/internal/core/v2/chargers/${chargerId}/${API_KEYS.MESSAGE}`,
        method: 'GET',
        params: {
          'filter[receivedTimeUtc][gte]': from,
          'filter[receivedTimeUtc][lte]': to,
          sort: '-receivedTimeUtc',
          limit,
          scope: SCOPE_TYPE.ALL,
        },
        needCompanyId: false,
      }),
    }),
    exportOcppMessages: builder.query<any, any>({
      query: (params) => ({
        url: `/internal/core/v2/chargers/${params.chargerId}/${API_KEYS.MESSAGE}`,
        params,
        method: 'GET',
        isCSV: true,
        responseHandler: (response) =>
          response
            .blob()
            .then(
              (blob) =>
                blob.size > 0 && downloadBlob(blob, `${params.chargerName} messages`, 'csv'),
            ),
      }),
    }),
  }),
});

export const {
  useFetchOcppMessagesQuery,
  useLazyFetchOcppMessagesQuery,
  useLazyFetchOcppMessagesByChargerQuery,
  useLazyExportOcppMessagesQuery,
} = ocppMessagesApi;
